import { render, staticRenderFns } from "./RemoteMonitoringTemplatesView.vue?vue&type=template&id=cc244d16"
import script from "./RemoteMonitoringTemplatesView.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringTemplatesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports